export const formatCount = (count: number | undefined) => {
  if (!count) {
    return 0;
  }
  return count >= 1000 ? '1K+' : count;
};
